import AvatarImage from 'ui/Element/Image/Avatar'
import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'

const styles = () => ({
  icon: {
    width: '2.5rem',
    minHeight: '2.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Displays the icon of an measurement.
 *
 * @todo Use generic cell component
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmMeasurementIcon = (classes, props = {}) => (
  <Grid
    item
    className={classes.icon}
  >
    <AvatarImage
      shape={'circle'}
      fallbackIcon={{
        size: '50%',
        name: 'bar-line-chart',
        color: 'black.main',
        background: 'gray.960',
      }}
    />
  </Grid>

)

export default CellHOC(ListItemCellXEcoApmMeasurementIcon, styles)
